export default __webpack_public_path__ + "93c1301bd9f486c573b3d9001c6ec0e4.woff";